module.exports = require("./gsw.js");